import { render, staticRenderFns } from "./NextStepButton.vue?vue&type=template&id=4b8380b2&"
import script from "./NextStepButton.vue?vue&type=script&lang=js&"
export * from "./NextStepButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports